type Props = {
  value: any
}

const SimpleValueCell = ({ value } : Props) => (value)

export { SimpleValueCell }
